import storeManager from '../../store/StoreManager';

const flaggedItemsReader = {
    isItemFlagged(contentRevisionId) {
        const { itemFlag: { flaggedItems } } = storeManager.getState();
        const contentRevisionIdRegex = new RegExp(contentRevisionId); // or use a custom pattern
        return flaggedItems.some(item => contentRevisionIdRegex.test(item));
    },

    isItemFocused(contentRevisionId) {
        const { itemFlag: { focusedItem } } = storeManager.getState();
        return focusedItem === contentRevisionId;
    },
};

export default flaggedItemsReader;
